<template>
  <div class="mt-5">
    <h2>Support-meldinger</h2>
    <div class="d-flex justify-content-between">
      <div>
        <b-button :to="{ name: 'messages.compose' }" variant="primary" size="sm" class="mb-2">
          Ny melding
        </b-button>
      </div>
      <div>
        <b-pagination
          size="sm"
          v-model="currentPage"
          :total-rows="threads.length"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <div v-if="threads.length > 0">
      <b-table
        hover
        :items="threads"
        :fields="fields"
        :tbody-tr-class="rowClass"
        @row-clicked="viewThread"
        class="hover"
      >
        <template slot="messages" slot-scope="row">
          {{ row.item.messages[0].body }}
        </template>
        <template slot="last_message" slot-scope="row">
          {{ row.item.messages[0].updated_at }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  mounted() {
    this.getThreads();
  },
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      fields: [
        {
          key: 'subject',
          label: 'Emne',
        },
        {
          key: 'messages',
          label: 'Siste melding',
        },
        {
          key: 'last_message',
          label: 'Sist oppdatert',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      threads: 'messages/threads',
    }),
  },
  methods: {
    ...mapActions({
      getThreads: 'messages/getThreads',
      getThread: 'messages/getThread',
    }),
    rowClass(item, type) {
      if (!item) return;
      if (item.unread === true) return 'table-light font-weight-bold';
    },
    viewThread(thread) {
      this.getThread(thread.id).then(_ => {
        this.$router.push({ name: 'messages.show', params: { id: thread.id } });
      });
    },
  },
};
</script>

<style>
.hover tbody tr {
  cursor: pointer;
}
</style>
